/* =========================================================
   AFS SLIDER
========================================================= */

document.addEventListener('DOMContentLoaded', () => {

  const sliderEnabled = (track) => {

    const isMobile = window.innerWidth <= 749;
    const isTablet = window.innerWidth >= 750 && window.innerWidth <= 989;
    const isDesktop = window.innerWidth >= 990;

    if (isMobile) {
      return track.classList.contains('afs-grid-scroll-mobile');
    }

    if (isTablet) {
      return track.classList.contains('afs-grid-scroll-tablet');
    }

    return track.classList.contains('afs-grid-scroll-desktop');
  };

  document.querySelectorAll('.afs-slider').forEach((slider) => {

    const track = slider.querySelector('[data-afs-slider]');
    const prev = slider.querySelector('.afs-slider__arrow--prev');
    const next = slider.querySelector('.afs-slider__arrow--next');

    if (!track || !prev || !next) return;

    /* Hide navigation when slider is disabled */
    if (!sliderEnabled(track)) {
      prev.style.display = 'none';
      next.style.display = 'none';
      return;
    }

    prev.style.display = '';
    next.style.display = '';

    const getScrollAmount = () => {
      const firstItem = track.children[0];

      if (!firstItem) {
        return track.clientWidth * 0.85;
      }

      const itemWidth = firstItem.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;

      return itemWidth + gap;
    };

    const goNext = () => {

      const maxScroll = track.scrollWidth - track.clientWidth;

      if (track.scrollLeft >= maxScroll - 10) {
        track.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
      } else {
        track.scrollBy({
          left: getScrollAmount(),
          behavior: 'smooth'
        });
      }

    };

    const goPrev = () => {

      const maxScroll = track.scrollWidth - track.clientWidth;

      if (track.scrollLeft <= 10) {
        track.scrollTo({
          left: maxScroll,
          behavior: 'smooth'
        });
      } else {
        track.scrollBy({
          left: -getScrollAmount(),
          behavior: 'smooth'
        });
      }

    };

    next.addEventListener('click', goNext);
    prev.addEventListener('click', goPrev);

  });

});

// Before and after snippet script

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-afs-comparison-card]').forEach((card) => {
    const media = card.querySelector('.afs-comparison-card__media');
    const handle = card.querySelector('[data-afs-comparison-handle]');

    if (!media || !handle) return;

    let isDragging = false;

    const setPosition = (clientX) => {
      const rect = media.getBoundingClientRect();
      const x = clientX - rect.left;
      let percent = (x / rect.width) * 100;

      percent = Math.max(5, Math.min(95, percent));
      card.style.setProperty('--afs-comparison-position', `${percent}%`);
    };

    const startDrag = (event) => {
      isDragging = true;
      media.classList.add('is-dragging');
      setPosition(event.touches ? event.touches[0].clientX : event.clientX);
    };

    const moveDrag = (event) => {
      if (!isDragging) return;
      setPosition(event.touches ? event.touches[0].clientX : event.clientX);
    };

    const stopDrag = () => {
      isDragging = false;
      media.classList.remove('is-dragging');
    };

    media.addEventListener('mousedown', startDrag);
    media.addEventListener('touchstart', startDrag, { passive: true });

    window.addEventListener('mousemove', moveDrag);
    window.addEventListener('touchmove', moveDrag, { passive: true });

    window.addEventListener('mouseup', stopDrag);
    window.addEventListener('touchend', stopDrag);
  });
});


// testimonial animation fadeup
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-afs-fade-slider]').forEach((slider) => {
    const slides = Array.from(slider.querySelectorAll('.afs-store-reviews__item'));
    const section = slider.closest('.afs-store-reviews');
    const prev = section?.querySelector('.afs-slider__arrow--prev');
    const next = section?.querySelector('.afs-slider__arrow--next');

    if (!slides.length) return;

    let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (index < 0) index = 0;

    const autoplay = slider.dataset.autoplay === 'true';
    const interval = Number(slider.dataset.interval || 5000);
    let timer = null;

    const showSlide = (nextIndex) => {
      slides[index].classList.remove('is-active');
      index = (nextIndex + slides.length) % slides.length;
      slides[index].classList.add('is-active');
    };

    const restartAutoplay = () => {
      if (!autoplay || slides.length <= 1) return;
      clearInterval(timer);
      timer = setInterval(() => {
        showSlide(index + 1);
      }, interval);
    };

    next?.addEventListener('click', () => {
      showSlide(index + 1);
      restartAutoplay();
    });

    prev?.addEventListener('click', () => {
      showSlide(index - 1);
      restartAutoplay();
    });

    restartAutoplay();
  });
});

// Product Gallery 
document.addEventListener('click', function (event) {
  const thumb = event.target.closest('[data-afs-gallery-thumb]');
  if (!thumb) return;

  const gallery = thumb.closest('[data-afs-product-gallery]');
  if (!gallery) return;

  const index = thumb.getAttribute('data-afs-gallery-thumb');

  gallery.querySelectorAll('[data-afs-gallery-thumb]').forEach((item) => {
    item.classList.remove('is-active');
  });

  gallery.querySelectorAll('[data-afs-gallery-panel]').forEach((panel) => {
    panel.classList.remove('is-active');
  });

  thumb.classList.add('is-active');

  const activePanel = gallery.querySelector(`[data-afs-gallery-panel="${index}"]`);
  if (activePanel) {
    activePanel.classList.add('is-active');
  }
});

/* =========================================================
   AFS PRODUCT STICKY BAR
========================================================= */

function initProductStickyBar() {
  const stickyBar = document.querySelector('[data-afs-product-sticky-bar]');
  const buyBox = document.querySelector('.afs-product-buy-box');
  const mainForm = document.querySelector('.afs-product-form');
  const stickyButton = document.querySelector('[data-afs-sticky-add]');

  if (!stickyBar || !buyBox || !mainForm || !stickyButton) {
    return;
  }

  // Prevent duplicate observers when Shopify reloads sections
  if (stickyBar.dataset.initialized === 'true') {
    return;
  }

  stickyBar.dataset.initialized = 'true';

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('is-visible');
          stickyBar.setAttribute('hidden', '');
        } else {
          stickyBar.removeAttribute('hidden');

          requestAnimationFrame(() => {
            stickyBar.classList.add('is-visible');
          });
        }
      });
    },
    {
      threshold: 0
    }
  );

  observer.observe(buyBox);

  stickyButton.addEventListener('click', () => {
    const submitButton = mainForm.querySelector(
      'button[type="submit"][name="add"]'
    );

    if (submitButton) {
      submitButton.click();
    }
  });
}

/* ---------- Init ---------- */

document.addEventListener('DOMContentLoaded', initProductStickyBar);
document.addEventListener('shopify:section:load', initProductStickyBar);


/* =========================================================
   AFS PRODUCT GALLERY
========================================================= */

/**
 * AFS Product Gallery
 *
 * Fixed primary media on the left.
 * Slider media on the right.
 */
(() => {
  function initializeProductGallery(gallery) {
    if (!gallery || gallery.dataset.afsGalleryInitialized === 'true') {
      return;
    }

    const slider = gallery.querySelector('[data-afs-gallery-slider]');
    const track = gallery.querySelector('[data-afs-gallery-track]');
    const slides = Array.from(
      gallery.querySelectorAll('[data-afs-gallery-slide]')
    );

    const previousButton = gallery.querySelector('[data-afs-gallery-prev]');
    const nextButton = gallery.querySelector('[data-afs-gallery-next]');
    const dots = Array.from(
      gallery.querySelectorAll('[data-afs-gallery-dot]')
    );

    if (!slider || !track || slides.length === 0) {
      return;
    }

    gallery.dataset.afsGalleryInitialized = 'true';

    let currentIndex = 0;
    let pointerStartX = null;
    let pointerEndX = null;

    function pauseInactiveVideos() {
      slides.forEach((slide, index) => {
        if (index === currentIndex) {
          return;
        }

        slide.querySelectorAll('video').forEach((video) => {
          video.pause();
        });
      });
    }

    function updateGallery(index) {
      const totalSlides = slides.length;

      if (totalSlides <= 0) {
        return;
      }

      currentIndex = (index + totalSlides) % totalSlides;

      track.style.transform = `translate3d(-${currentIndex * 100}%, 0, 0)`;

      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === currentIndex;

        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === currentIndex;

        dot.classList.toggle('is-active', isActive);

        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      pauseInactiveVideos();
    }

    previousButton?.addEventListener('click', () => {
      updateGallery(currentIndex - 1);
    });

    nextButton?.addEventListener('click', () => {
      updateGallery(currentIndex + 1);
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const requestedIndex = Number(
          dot.dataset.afsGalleryDot
        );

        if (Number.isNaN(requestedIndex)) {
          return;
        }

        updateGallery(requestedIndex);
      });
    });

    slider.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        updateGallery(currentIndex - 1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        updateGallery(currentIndex + 1);
      }
    });

    slider.addEventListener('pointerdown', (event) => {
      pointerStartX = event.clientX;
      pointerEndX = event.clientX;
    });

    slider.addEventListener('pointermove', (event) => {
      if (pointerStartX === null) {
        return;
      }

      pointerEndX = event.clientX;
    });

    slider.addEventListener('pointerup', () => {
      if (pointerStartX === null || pointerEndX === null) {
        return;
      }

      const movement = pointerStartX - pointerEndX;
      const swipeThreshold = 50;

      if (Math.abs(movement) >= swipeThreshold) {
        if (movement > 0) {
          updateGallery(currentIndex + 1);
        } else {
          updateGallery(currentIndex - 1);
        }
      }

      pointerStartX = null;
      pointerEndX = null;
    });

    slider.addEventListener('pointercancel', () => {
      pointerStartX = null;
      pointerEndX = null;
    });

    updateGallery(0);
  }

  function initializeAllProductGalleries(container = document) {
    container
      .querySelectorAll('[data-afs-product-gallery]')
      .forEach(initializeProductGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeAllProductGalleries();
    });
  } else {
    initializeAllProductGalleries();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllProductGalleries(event.target);
  });
})();

// AFS Collection tab 
document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-afs-grid-size]');
  if (!button) return;

  const grid = document.querySelector('[data-afs-collection-grid]');
  if (!grid) return;

  const size = button.getAttribute('data-afs-grid-size');

  grid.classList.remove(
    'afs-main-collection__grid--2',
    'afs-main-collection__grid--3',
    'afs-main-collection__grid--4'
  );

  grid.classList.add(`afs-main-collection__grid--${size}`);

  document.querySelectorAll('[data-afs-grid-size]').forEach((item) => {
    item.classList.remove('is-active');
  });

  button.classList.add('is-active');
});

/* =========================================================
   AFS COLLECTION FILTER DRAWER
========================================================= */

function initCollectionFilterDrawer() {
  const drawers = document.querySelectorAll('[data-afs-filter-drawer]');

  drawers.forEach((drawer) => {
    if (drawer.dataset.afsDrawerInitialized === 'true') return;
    drawer.dataset.afsDrawerInitialized = 'true';

    const openButtons = document.querySelectorAll('[data-afs-filter-open]');
    const closeButtons = drawer.querySelectorAll('[data-afs-filter-close]');
    let closeTimer = null;

    function openDrawer() {
      if (closeTimer) clearTimeout(closeTimer);

      drawer.classList.add('is-visible');

      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
      });

      document.body.classList.add('afs-overflow-hidden');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');

      closeTimer = setTimeout(() => {
        drawer.classList.remove('is-visible');
      }, 420);

      document.body.classList.remove('afs-overflow-hidden');
    }

    openButtons.forEach((button) => {
      button.addEventListener('click', openDrawer);
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('is-visible')) {
        closeDrawer();
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initCollectionFilterDrawer);
document.addEventListener('shopify:section:load', initCollectionFilterDrawer);

function initAFSPriceSlider() {
  document.querySelectorAll('[data-afs-price-slider]').forEach((slider) => {
    if (slider.dataset.afsPriceInitialized === 'true') return;
    slider.dataset.afsPriceInitialized = 'true';

    const min = Number(slider.dataset.min || 0);
    const max = Number(slider.dataset.max || 141);

    const minRange = slider.querySelector('[data-afs-price-min-range]');
    const maxRange = slider.querySelector('[data-afs-price-max-range]');
    const range = slider.querySelector('[data-afs-price-range]');

    const group = slider.closest('.afs-filter-group');
    const minInput = group.querySelector('[data-afs-price-min-input]');
    const maxInput = group.querySelector('[data-afs-price-max-input]');

    function clampValues() {
      let minValue = Number(minRange.value);
      let maxValue = Number(maxRange.value);

      if (minValue > maxValue) minValue = maxValue;
      if (maxValue < minValue) maxValue = minValue;

      minRange.value = minValue;
      maxRange.value = maxValue;

      minInput.value = minValue;
      maxInput.value = maxValue;

      const minPercent = ((minValue - min) / (max - min)) * 100;
      const maxPercent = ((maxValue - min) / (max - min)) * 100;

      range.style.left = `${minPercent}%`;
      range.style.right = `${100 - maxPercent}%`;
    }

    minRange.addEventListener('input', clampValues);
    maxRange.addEventListener('input', clampValues);

    minInput.addEventListener('input', () => {
      minRange.value = minInput.value || min;
      clampValues();
    });

    maxInput.addEventListener('input', () => {
      maxRange.value = maxInput.value || max;
      clampValues();
    });

    clampValues();
  });
}

document.addEventListener('DOMContentLoaded', initAFSPriceSlider);
document.addEventListener('shopify:section:load', initAFSPriceSlider);


/* =========================================================
   AFS COMPARISON GALLERY FILTER
========================================================= */

(() => {
  function initializeComparisonGallery(section) {
    if (
      !section ||
      section.dataset.afsComparisonGalleryInitialized === 'true'
    ) {
      return;
    }

    const filters = Array.from(
      section.querySelectorAll('[data-afs-comparison-filter]')
    );

    const items = Array.from(
      section.querySelectorAll('[data-afs-comparison-item]')
    );

    if (!filters.length || !items.length) {
      return;
    }

    section.dataset.afsComparisonGalleryInitialized = 'true';

    function getItemCategories(item) {
      return (item.dataset.afsComparisonCategories || '')
        .split(',')
        .map((category) => category.trim())
        .filter(Boolean);
    }

    function applyFilter(selectedCategory) {
      filters.forEach((filterButton) => {
        const isActive =
          filterButton.dataset.afsComparisonFilter === selectedCategory;

        filterButton.classList.toggle('is-active', isActive);
        filterButton.setAttribute(
          'aria-pressed',
          isActive ? 'true' : 'false'
        );
      });

      items.forEach((item) => {
        const itemCategories = getItemCategories(item);

        const shouldShow =
          selectedCategory === 'all' ||
          itemCategories.includes(selectedCategory);

        item.classList.toggle('is-hidden', !shouldShow);
        item.hidden = !shouldShow;
      });
    }

    filters.forEach((filterButton) => {
      filterButton.addEventListener('click', () => {
        const selectedCategory =
          filterButton.dataset.afsComparisonFilter;

        if (!selectedCategory) {
          return;
        }

        applyFilter(selectedCategory);
      });
    });

    const initiallyActiveFilter = filters.find((filterButton) =>
      filterButton.classList.contains('is-active')
    );

    applyFilter(
      initiallyActiveFilter?.dataset.afsComparisonFilter || 'all'
    );
  }

  function initializeAllComparisonGalleries(container = document) {
    const galleries = [];

    if (
      container.matches?.('[data-afs-comparison-gallery]')
    ) {
      galleries.push(container);
    }

    galleries.push(
      ...container.querySelectorAll?.(
        '[data-afs-comparison-gallery]'
      ) || []
    );

    galleries.forEach(initializeComparisonGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeAllComparisonGalleries();
    });
  } else {
    initializeAllComparisonGalleries();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllComparisonGalleries(event.target);
  });
})();

/* =========================================================
   AFS BUNDLE OFFER
========================================================= */

function initBundleOffer() {
  document.querySelectorAll('[data-afs-bundle-offer]').forEach((section) => {
    if (section.dataset.initialized === 'true') return;

    section.dataset.initialized = 'true';

    const button = section.querySelector('[data-afs-bundle-add]');
    const productsJson = section.querySelector('[data-afs-bundle-products]');

    if (!button || !productsJson) return;

    let items = [];

    try {
      items = JSON.parse(productsJson.textContent).filter((item) => item.id);
    } catch (error) {
      console.error('AFS Bundle Offer: invalid products JSON', error);
      return;
    }

    button.addEventListener('click', async () => {
      if (!items.length) return;

      button.disabled = true;
      button.classList.add('is-loading');

      try {
        await fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          }
        });

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        window.location.href = '/checkout';
      } catch (error) {
        console.error('AFS Bundle Offer: add bundle failed', error);
        button.disabled = false;
        button.classList.remove('is-loading');
      }
    });
  });
}

/* =========================================================
   AFS FAQ
========================================================= */
document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-faq-filter]');
  if (!button) return;

  const section = button.closest('.afs-faq');
  if (!section) return;

  const filter = button.getAttribute('data-faq-filter');

  section.querySelectorAll('[data-faq-filter]').forEach((btn) => {
    btn.classList.remove('is-active');
  });

  button.classList.add('is-active');

  section.querySelectorAll('[data-faq-category]').forEach((item) => {
    const category = item.getAttribute('data-faq-category');
    const shouldShow = filter === 'all' || category === filter;

    item.classList.toggle('is-hidden', !shouldShow);

    if (!shouldShow) item.removeAttribute('open');
  });

  section.querySelectorAll('[data-faq-group-heading]').forEach((heading) => {
    heading.classList.toggle('is-hidden', filter !== 'all');
  });
});


// Floating Video

function initAFSFloatingVideo() {
  const player = document.querySelector('[data-afs-floating-video]');
  if (!player) return;

  const video = player.querySelector('[data-afs-floating-video-media]');
  const close = player.querySelector('[data-afs-floating-video-close]');
  const triggers = document.querySelectorAll('[data-afs-video-trigger]');

  function isMobileViewport() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function shouldOpenPopup(trigger) {
    const isMobile = isMobileViewport();

    const desktopEnabled = trigger.dataset.videoPopupDesktop !== 'false';
    const mobileEnabled = trigger.dataset.videoPopupMobile !== 'false';

    if (isMobile && !mobileEnabled) return false;
    if (!isMobile && !desktopEnabled) return false;

    return true;
  }

  function openVideo(src, poster) {
    if (!src || !video) return;

    video.pause();
    video.removeAttribute('src');
    video.removeAttribute('poster');

    video.src = src;

    if (poster) {
      video.poster = poster;
    }

    player.classList.add('is-open');

    video.load();
    video.play().catch(() => {});
  }

  function closeVideo() {
    player.classList.remove('is-open');

    if (video) {
      video.pause();
      video.removeAttribute('src');
      video.load();
    }
  }

  triggers.forEach((trigger) => {
    if (trigger.dataset.afsVideoInitialized === 'true') return;
    trigger.dataset.afsVideoInitialized = 'true';

    trigger.addEventListener('click', () => {
      if (!shouldOpenPopup(trigger)) return;

      openVideo(trigger.dataset.videoSrc, trigger.dataset.videoPoster);
    });
  });

  if (close && close.dataset.afsVideoCloseInitialized !== 'true') {
    close.dataset.afsVideoCloseInitialized = 'true';
    close.addEventListener('click', closeVideo);
  }

  if (document.documentElement.dataset.afsVideoEscInitialized !== 'true') {
    document.documentElement.dataset.afsVideoEscInitialized = 'true';

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeVideo();
    });
  }
}

document.addEventListener('DOMContentLoaded', initAFSFloatingVideo);
document.addEventListener('shopify:section:load', initAFSFloatingVideo);


// How it works reveal on hover shit
/**
 * AFS Personalization Process
 *
 * Reveals the heading and cards once the section enters the viewport.
 */
(() => {
  function initializePersonalizationProcess(section) {
    if (
      !section ||
      section.dataset.afsPersonalizationInitialized === 'true'
    ) {
      return;
    }

    section.dataset.afsPersonalizationInitialized = 'true';

    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      section.classList.add('is-visible');
      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add('is-visible');
          currentObserver.unobserve(entry.target);
        });
      },
      {
        threshold: 0.18,
        rootMargin: '0px 0px -8% 0px',
      }
    );

    observer.observe(section);
  }

  function initializeAllPersonalizationProcesses(container = document) {
    container
      .querySelectorAll('[data-afs-personalization-process]')
      .forEach(initializePersonalizationProcess);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeAllPersonalizationProcesses();
    });
  } else {
    initializeAllPersonalizationProcesses();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllPersonalizationProcesses(event.target);
  });
})();


// Amend Judge NMe review icons

/**
 * Judge.me reviewer initials
 * Examples:
 * J.G.         → JG
 * Chaitanya D. → CD
 * John Parker  → JP
 * Chaitanya    → CH
 */
(() => {
  function getReviewerInitials(name) {
    if (!name) return '';

    const normalizedName = name
      .trim()
      .replace(/\s+/g, ' ');

    /*
     * Handles dotted abbreviations such as J.G.
     */
    const dottedInitials = normalizedName.match(
      /[\p{L}\p{N}](?=\.)/gu
    );

    if (dottedInitials && dottedInitials.length >= 2) {
      return dottedInitials
        .slice(0, 2)
        .join('')
        .toUpperCase();
    }

    const words = normalizedName
      .split(' ')
      .map((word) =>
        word.replace(/[^\p{L}\p{N}]/gu, '')
      )
      .filter(Boolean);

    /*
     * Chaitanya D. → CD
     * John Parker → JP
     */
    if (words.length >= 2) {
      return (
        words[0].charAt(0) +
        words[words.length - 1].charAt(0)
      ).toUpperCase();
    }

    /*
     * Chaitanya → CH
     */
    if (words.length === 1) {
      return words[0].slice(0, 2).toUpperCase();
    }

    return '';
  }

  function updateJudgeMeInitials(container = document) {
    const profiles = container.matches?.('.jdgm-row-profile')
      ? [container]
      : container.querySelectorAll?.('.jdgm-row-profile') || [];

    profiles.forEach((profile) => {
      const icon = profile.querySelector('.jdgm-rev__icon');
      const author = profile.querySelector('.jdgm-rev__author');

      if (!icon || !author) return;

      const initials = getReviewerInitials(
        author.textContent
      );

      if (!initials) return;

      icon.setAttribute('data-afs-initials', initials);
      icon.setAttribute('aria-hidden', 'true');
      icon.classList.add('afs-reviewer-initials');
    });
  }

  let updateQueued = false;

  function queueInitialsUpdate() {
    if (updateQueued) return;

    updateQueued = true;

    requestAnimationFrame(() => {
      updateQueued = false;
      updateJudgeMeInitials(document);
    });
  }

  function initializeJudgeMeInitials() {
    queueInitialsUpdate();

    const observer = new MutationObserver(() => {
      queueInitialsUpdate();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    /*
     * Judge.me can render in several asynchronous stages.
     */
    [300, 800, 1500, 3000].forEach((delay) => {
      window.setTimeout(queueInitialsUpdate, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeJudgeMeInitials
    );
  } else {
    initializeJudgeMeInitials();
  }

  document.addEventListener(
    'shopify:section:load',
    queueInitialsUpdate
  );
})();